var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMessageHeartSquare(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5 9.1c0-1.96 0-2.94.38-3.69a3.5 3.5 0 0 1 1.53-1.53c.75-.38 1.73-.38 3.69-.38h9.8c1.96 0 2.94 0 3.69.38.66.34 1.2.87 1.53 1.53.38.75.38 1.73.38 3.69v6.3c0 1.96 0 2.94-.38 3.69a3.5 3.5 0 0 1-1.53 1.53c-.75.38-1.73.38-3.69.38h-2.94c-.72 0-1.09 0-1.44.07-.3.06-.6.17-.88.31-.32.16-.6.4-1.17.85l-2.79 2.22c-.48.4-.73.59-.93.59a.58.58 0 0 1-.46-.22c-.12-.16-.12-.47-.12-1.1V21c-1.09 0-1.63 0-2.08-.12a3.5 3.5 0 0 1-2.47-2.47c-.12-.45-.12-1-.12-2.08V9.1Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14 8.98c-1.05-1.21-2.8-1.54-4.12-.43a3.06 3.06 0 0 0-.47 4.28c.64.82 2.25 2.3 3.38 3.31.41.38.62.56.87.64.21.06.46.06.67 0 .25-.08.46-.27.87-.64a36.95 36.95 0 0 0 3.38-3.3 3.04 3.04 0 0 0-.47-4.29c-1.34-1.1-3.06-.78-4.11.43Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageHeartSquare);
export default __webpack_public_path__ + "static/media/message-heart-square.c7c97e548123b7e5e75324dbb19a0a6c.svg";
export { ForwardRef as ReactComponent };